import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import { notification } from "antd";
import { HiOutlineMail, HiOutlineArrowLeft, HiOutlineKey } from 'react-icons/hi';

function Forgot() {
  let Var_History = useHistory();

  const [Var_Email, setVar_Email] = useState("");
  const [Var_EmailErr, setVar_EmailErr] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOnClick = (path) => {
    Var_History.push(path);
  };

  const submitMail = async (e) => {
    e.preventDefault();
    if (!Var_Email) {
      setVar_EmailErr(true);
      return;
    }

    setVar_EmailErr(false);
    setLoading(true);

    try {
      const host = window.location.host;
      const obj_data = {
        email: Var_Email,
        host,
        pathname: "",
        module: "Doctor",
      };

      const response = await axiosInstance.post("doctor/forgot_password_check_mail", obj_data);

      if (response.data.status === 1) {
        notification.success({
          message: response.data.msg,
        });
        handleOnClick("/");
      } else {
        notification.error({
          message: response.data.msg,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] overflow-hidden flex flex-col p-8 sm:p-10 relative">

        {/* Back to Login Button */}
        <button
          onClick={() => handleOnClick("/")}
          className="absolute top-8 left-8 text-gray-400 hover:text-teal-600 transition-colors flex items-center gap-1.5 text-sm font-medium border-none bg-transparent cursor-pointer"
        >
          <HiOutlineArrowLeft /> Back
        </button>

        <div className="flex flex-col items-center mt-6">
          <div className="w-16 h-16 bg-teal-50 text-teal-600 rounded-2xl flex items-center justify-center mb-6 shadow-sm border border-teal-100">
            <HiOutlineKey size={28} />
          </div>

          <div className="mb-8 text-center">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">Forgot Password?</h1>
            <p className="text-sm text-gray-500 leading-relaxed px-2">
              Enter your email address and we'll send you a link to reset your password.
            </p>
          </div>

          <form onSubmit={submitMail} className="w-full space-y-5">
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wider">Email Address</label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-teal-600 transition-colors">
                  <HiOutlineMail className="h-5 w-5" />
                </div>
                <input
                  type="email"
                  className={`block w-full pl-10 pr-4 py-3 border-2 ${Var_EmailErr ? 'border-red-500' : 'border-gray-100'} rounded-xl focus:ring-4 focus:ring-teal-500/10 focus:border-teal-500 transition-all outline-none text-gray-800 bg-white placeholder:text-gray-400 text-sm`}
                  placeholder="name@example.com"
                  value={Var_Email}
                  onChange={(e) => {
                    setVar_Email(e.target.value);
                    if (Var_EmailErr) setVar_EmailErr(false);
                  }}
                />
              </div>
              {Var_EmailErr && <p className="mt-1.5 text-xs text-red-500 font-semibold ml-1">Please enter a valid email address</p>}
            </div>

            <div className="space-y-3 pt-2">
              <button
                type="submit"
                disabled={loading}
                className={`w-full py-3.5 px-6 rounded-xl text-white font-bold text-base shadow-lg transform transition-all active:scale-[0.98] border-none cursor-pointer ${loading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 hover:shadow-teal-100 shadow-teal-500/30 hover:-translate-y-0.5'
                  }`}
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing...
                  </span>
                ) : "Send Reset Link"}
              </button>

              <button
                type="button"
                onClick={() => handleOnClick("/")}
                className="w-full py-3 px-6 rounded-xl text-gray-500 font-semibold text-sm hover:bg-gray-50 transition-colors text-center border-none bg-transparent cursor-pointer"
              >
                Cancel
              </button>
            </div>
          </form>

          <p className="mt-8 text-center text-xs sm:text-sm text-gray-500">
            Remember your password? <span onClick={() => handleOnClick("/")} className="text-teal-600 font-semibold cursor-pointer hover:underline">Sign In</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Forgot;
